/**
 * Responsive Features Module
 *
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

/**
 * Initialize responsive features
 */
export function initResponsiveFeatures() {
    // Adjust hero text size based on viewport
    const heroHeadings = document.querySelectorAll('.hero-section .wp-block-heading');

    function adjustHeroText() {
        heroHeadings.forEach(heading => {
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            if (vw < 768) {
                heading.style.fontSize = 'clamp(1.5rem, 8vw, 2.5rem)';
            } else {
                heading.style.fontSize = '';
            }
        });
    }

    adjustHeroText();
    window.addEventListener('resize', adjustHeroText);
}

/**
 * Utility function to detect if user prefers reduced motion
 */
export function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}